import { Avatar, Box, Card, Stack, Typography } from "@mui/material";
import CoverImageSecurityItem from "./CoverImageSecurityItem";
import { useTranslation } from "react-i18next";

const CoverImageSecurity = () => {
    const { t } = useTranslation();

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ px: 3, mt: 3, gap: { xs: "6px", sm: "12px" } }}
        >
            <CoverImageSecurityItem imgSrc="/assets/icons/security/security.svg">
                <Typography fontSize="14px" fontWeight={600} lineHeight="18px">
                    {t("checkout.security.purchase")}
                </Typography>
                <Typography fontSize="14px" fontWeight={600} lineHeight="18px">
                    {t("checkout.security.secure")}
                </Typography>
            </CoverImageSecurityItem>

            <CoverImageSecurityItem imgSrc="/assets/icons/security/satisfaction.svg">
                <Typography fontSize="14px" fontWeight={600} lineHeight="18px">
                    {t("checkout.security.satisfaction")}
                </Typography>
                <Typography fontSize="14px" fontWeight={600} lineHeight="18px">
                    {t("checkout.security.guaranteed")}
                </Typography>
            </CoverImageSecurityItem>

            <CoverImageSecurityItem imgSrc="/assets/icons/security/privacy.svg">
                <Typography fontSize="14px" fontWeight={600} lineHeight="18px">
                    {t("checkout.security.privacy")}
                </Typography>
                <Typography fontSize="14px" fontWeight={600} lineHeight="18px">
                    {t("checkout.security.protected")}
                </Typography>
            </CoverImageSecurityItem>
        </Stack>
    );
};

export default CoverImageSecurity;
